import {
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
  Button,
  Space,
  Text,
  Flex,
  Stack,
} from '@tonic-one/react';
import { t } from 'i18next';
import { CorrelatedRuleShallow } from '../types';
import { FormLabel } from '@Components/Common/FormComponent';
import LoadingBtn from '@Components/Common/LoadingBtn';

const DeleteRuleModal = (props: {
  rule: CorrelatedRuleShallow;
  isOpen: boolean;
  onConfirm: () => Promise<void>;
  onClose: () => void;
}) => {
  const { rule, isOpen, onClose, onConfirm } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      closeOnEsc
      closeOnOutsideClick
      isClosable
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>
          {t('globalSetting.correlatedRules.deleteRuleModal.title')}
        </ModalHeader>
        <ModalBody>
          <Stack gap="4x">
            <Text>
              {t('globalSetting.correlatedRules.deleteRuleModal.content')}
            </Text>
            <Flex>
              <FormLabel
                label={t('globalSetting.correlatedRules.table.ruleName')}
              />
              <Text height="max-content" alignSelf="center">
                {rule.raiRuleName}
              </Text>
            </Flex>
            {rule.raiRuleDesc !== '' && (
              <Flex>
                <FormLabel
                  label={t('globalSetting.correlatedRules.table.description')}
                />
                <Text height="max-content" alignSelf="center">
                  {rule.raiRuleDesc}
                </Text>
              </Flex>
            )}
          </Stack>
        </ModalBody>
        <ModalFooter>
          <LoadingBtn variant="primary" onClick={onConfirm}>
            {t('common.action.label.confirm')}
          </LoadingBtn>
          <Space width="2x" />
          <Button onClick={onClose}>{t('common.button.cancel')}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteRuleModal;
